<div class="drawer-app-custom {{
    isDrawerSRequestWorkforcePlanDetails ? 'drawer-app-request-wfp' : ''
  }} {{ data?.type === DrawerTypes.REQUEST_FEEDBACK ? 'drawer-app-feedback' : '' }} {{ data?.type === DrawerTypes.EMPLOYEE_DETAILS ? 'drawer-app-employee-details' : '' }}"
	*ngIf="isDrawerOpened" [class.open]="isDrawerOpened">
	<div class="drawer-overlay"></div>

	<div class="drawer-wrapper">
		<div class="drawer-content">
			<div class="drawer-header px-2 py-1 d-flex align-items-center justify-content-between">
				<div>
					<ng-container *ngIf="!data?.type">
						<span class="text-md">{{ drawerTitle }}</span>
					</ng-container>
					<ng-container *ngIf="data?.type && data?.mode === 'add'">
						<span class="text-md">{{ drawerTitle }}</span>
					</ng-container>
					<ng-container *ngIf="data?.type && data?.mode === 'details'">
						<span class="text-md">Detalhes da Solicitação</span>
						<span class="text-xs">{{ drawerTitle }}</span>
					</ng-container>
				</div>
				<button class="btn btn-icon" (click)="handleCancel()" [disabled]="isSubmittingForm">
					<i class="feather icon-x"></i>
				</button>
			</div>

			<hr class="m-0" />

			<form [formGroup]="form" class="form p-2"
				[class.training-completion-gate-blocked]="isTrainingCompletionBlocked">
				<ng-container *ngIf="drawerStatus === 'loading'">
					<div class="spinner-container flex align-items-center justify-content-center">
						<span class="spinner-border text-primary"></span>
					</div>
				</ng-container>

				<ng-container *ngIf="drawerStatus === 'fetched'">
					<app-approval-scope-opening-instructions-banner *ngIf="showOpeningInstructionsBanner"
						[instructions]="openingInstructionsText" [approvalScopeId]="openingInstructionsApprovalScopeId"
						[canHidePreference]="openingInstructionsCanHidePreference"
						(dismissed)="onOpeningInstructionsDismissed()">
					</app-approval-scope-opening-instructions-banner>
					<app-approval-scope-opening-instructions-banner *ngIf="showStepInstructionsBanner"
						[instructions]="stepInstructionsText" [dismissible]="false" title="Instruções da etapa">
					</app-approval-scope-opening-instructions-banner>
					<div *ngIf="openingInstructionsContextFailed" class="alert alert-warning" role="alert">
						{{ openingContextFailureMessage }}
					</div>
					<div *ngIf="isTrainingCompletionBlocked" class="alert alert-warning" role="alert">
						{{ trainingCompletionBlockMessage || 'Ainda não está no prazo para aprovar a solicitação de
						treinamento.' }}
					</div>
					<div *ngIf="conversionLinkMessage" class="alert alert-info" role="alert">
						{{ conversionLinkMessage }}
					</div>
					<ng-container *ngIf="data?.mode === 'add'">
						<div *ngIf="data?.type === DrawerTypes.EMPLOYEE_DETAILS">
							<ng-container *ngTemplateOutlet="employeeDetails; context: { form: form }"></ng-container>
						</div>

						<div *ngIf="data?.type === DrawerTypes.REQUEST_TRAINING">
							<app-internal-training-form #solicitationFormRef [data]="data"
								[hiddenStandardFields]="hiddenStandardFields" [source]="source"
								(employeeLoadingChange)="onEmployeeLoadingChange($event)"></app-internal-training-form>
						</div>

						<div *ngIf="data?.type === DrawerTypes.REQUEST_APTITUDE_TRAINING">
							<ng-container
								*ngTemplateOutlet="requestAptitudeTrainingForm; context: { form: form }"></ng-container>
						</div>

						<div *ngIf="data?.type === DrawerTypes.FUNCTION_CHANGE">
							<ng-container
								*ngTemplateOutlet="functionChangeForm; context: { form: form }"></ng-container>
						</div>

						<div *ngIf="data?.type === DrawerTypes.COST_CENTER_AND_JOB_TITLE_CHANGE">
							<app-cost-center-change-form #solicitationFormRef [data]="data"
								[hiddenStandardFields]="hiddenStandardFields" [source]="source"
								[canChangeToDifferentCostCenter]="canChangeToDifferentCostCenter"
								(employeeLoadingChange)="onEmployeeLoadingChange($event)"></app-cost-center-change-form>
						</div>

						<div *ngIf="data?.type === DrawerTypes.SHIFT_CHANGE">
							<ng-container *ngTemplateOutlet="shiftChangeForm; context: { form: form }"></ng-container>
						</div>

						<div *ngIf="data?.type === DrawerTypes.REQUEST_DISMISSAL">
							<app-dismissal-form #solicitationFormRef [data]="data"
								[hiddenStandardFields]="hiddenStandardFields" [source]="source"
								(employeeLoadingChange)="onEmployeeLoadingChange($event)"></app-dismissal-form>
						</div>

						<div *ngIf="data?.type === DrawerTypes.REQUEST_DISCIPLINARY_MEASURE">
							<ng-container *ngTemplateOutlet="
                requestDisciplinaryForm;
                context: { form: form }
              "></ng-container>
						</div>

						<div *ngIf="data?.type === DrawerTypes.REQUEST_FEEDBACK">
							<ng-container *ngTemplateOutlet="requestFeedback; context: { form: form }"></ng-container>
						</div>

						<div *ngIf="data?.type === DrawerTypes.REQUEST_HIRING_INCREASE">
							<ng-container *ngTemplateOutlet="requestHiringForm; context: { form: form }"></ng-container>
						</div>

						<div *ngIf="data?.type === DrawerTypes.REQUEST_HIRING_SUBSTITUTION">
							<ng-container *ngTemplateOutlet="
                requestHiringSubstitutionForm;
                context: { form: form }
              "></ng-container>
						</div>

						<div *ngIf="data?.type === DrawerTypes.REQUEST_HIRING_REPLACEMENT">
							<ng-container *ngTemplateOutlet="
                requestHiringReplacementForm;
                context: { form: form }
              "></ng-container>
						</div>

						<div *ngIf="data?.type === DrawerTypes.REQUEST_PROMOTION">
							<app-promotion-form #solicitationFormRef [data]="data"
								[hiddenStandardFields]="hiddenStandardFields" [source]="source"
								(employeeLoadingChange)="onEmployeeLoadingChange($event)"></app-promotion-form>
						</div>

						<div *ngIf="data?.type === DrawerTypes.REQUEST_WORK_FORCEPLAN">
							<app-drawer-workforceplan-solicitation-planning #solicitationFormRef [data]="data"
								[source]="source"></app-drawer-workforceplan-solicitation-planning>
						</div>

						<ng-container *ngTemplateOutlet="customFieldsSection"></ng-container>

						<div class="drawer-actions d-flex gap-4 justify-content-end">
							<button class="btn btn-light" (click)="handleCancel()" [disabled]="isSubmittingForm">
								Cancelar
							</button>

							<ng-container
								*ngIf="data?.type !== DrawerTypes.EMPLOYEE_DETAILS && data?.type !== DrawerTypes.REQUEST_FEEDBACK">
								<button class="btn btn-primary" (click)="handleSubmit()"
									[disabled]="isSubmittingForm || !isCurrentSolicitationFormValid || openingInstructionsContextFailed">
									<span *ngIf="isSubmittingForm" class="spinner-border spinner-border-sm"></span>
									Solicitar
								</button>
							</ng-container>

							<ng-container *ngIf="data?.type === DrawerTypes.REQUEST_FEEDBACK">
								<button class="btn btn-primary" (click)="handleCreateView()"
									[disabled]="isSubmittingForm">
									<span *ngIf="isSubmittingForm" class="spinner-border spinner-border-sm"></span>
									Enviar novo Feedback
								</button>
							</ng-container>
						</div>
					</ng-container>

					<ng-container *ngIf="data?.mode === 'details'">
						<ng-container *ngIf="!isDrawerSRequestWorkforcePlanDetails">
							<div class="d-flex flex-column">
								<span>Solicitante</span>

								<div class="mt-1 d-flex gap-2 align-items-center">
									<img alt="avatar" class="avatar" [width]="36" [height]="36" [src]="
                    data?.solicitationDetails?.requesterImage ||
                    'assets/images/logo/avatar-profile.png'
                  " />

									<div class="d-flex">
										<span class="font-weight-bolder">{{
											data?.solicitationDetails?.requesterName
											}}</span>
									</div>
								</div>
							</div>

							<ng-container *ngIf="data?.solicitation?.employeeId">
								<div class="mt-2 d-flex flex-column">
									<span>Colaborador</span>

									<div class="mt-1 d-flex gap-3 align-items-center"
										*ngIf="!isEmployeeLoading; else employeeLoadingTpl">
										<img alt="avatar" class="avatar" [width]="36" [height]="36"
											[src]="data?.solicitation?.employeeImage || 'assets/images/logo/avatar-profile.png' " />

										<div class="d-flex flex-column">
											<span class="font-weight-bolder">{{ data?.solicitation?.employeeName
												}}</span>
											<div>
												<span class="text-xs">MAT: {{ data?.employee?.registration }}</span>
												<span class="align-self-center ml-1 cursor-pointer"
													*ngIf="employeeHasExtraInfo" [ngbTooltip]="empInfo"
													container="body">
													<i class="custom-icon-information-circle"></i>
												</span>
												<ng-template #empInfo>
													<p class="card-text font-small-3 mb-0 text-wrap">
														Centro de custo atual: {{ data?.employee?.costCenterName }}
													</p>
													<p class="card-text font-small-3 mb-0 text-wrap">
														Função atual: {{ data?.employee?.jobTitleName }}
													</p>
												</ng-template>
											</div>
										</div>
									</div>
									<ng-template #employeeLoadingTpl>
										<div class="mt-1 d-flex align-items-center gap-2 text-muted" aria-live="polite"
											aria-busy="true">
											<span class="spinner-border spinner-border-sm" role="status"
												aria-hidden="true"></span>
											<span>Carregando dados do colaborador...</span>
										</div>
									</ng-template>
								</div>
							</ng-container>

							<ng-container *ngIf="data?.solicitation?.steps">
								<div class="mt-2 d-flex flex-column">
									<span>Fluxo de aprovação</span>

									<div class="alert alert-warning mt-1 mb-0 p-1" *ngIf="isSolicitationCanceled">
										<div>
											Cancelada em {{ data?.solicitationDetails?.canceledAt | date: 'dd/MM/yyyy
											HH:mm' }}
											<ng-container *ngIf="data?.solicitationDetails?.canceledByName">
												por {{ data?.solicitationDetails?.canceledByName }}
											</ng-container>
										</div>
										<div class="text-wrap">Motivo: {{ data?.solicitationDetails?.cancellationReason
											}}</div>
									</div>

									<ul class="timeline timeline-approvers mt-2">
										<ng-container *ngFor="let step of data?.solicitation?.steps.slice(1)">
											<li class="timeline-item">
												<span class="timeline-point timeline-point-indicator {{
                          getColorIndicator(step?.status)
                        }} "></span>
												<div class="timeline-event">
													<span class="font-weight-bolder">
														{{ step?.stepName }}</span>
													<span class="align-self-center ml-1 cursor-pointer"
														*ngIf="step?.note" [ngbTooltip]="stepNote">
														<i class="custom-icon-comment"></i>
													</span>
													<ng-template #stepNote>
														<p class="card-text font-small-3 mb-0 text-wrap">
															{{ step?.note }}
														</p>
													</ng-template>

													<div class="timeline-event__infos mt-1">
														<div class="avatar avatar-md mr-1" *ngIf="
                              step.status === 'APPROVED' ||
                              step.status === 'REJECTED'
                            ">
															<img class="avatar" [width]="34" [height]="34" [src]="
                                step.approverImage ||
                                'assets/images/logo/avatar-profile.png'
                              " />
														</div>

														<span>{{ getApprovalResponsible(step) }}</span>
													</div>
												</div>
											</li>
										</ng-container>
									</ul>
								</div>
							</ng-container>



							<div class="mt-2" *ngIf="data?.mode === 'details' && hasSolicitationFiles">
								<div class="card card-fit shadow rounded-lg solicitation-files-card">
									<div class="card-header border-bottom py-1 px-2">
										<span class="solicitation-files-card__title">Arquivos</span>
									</div>
									<div class="card-body p-2">
										<div *ngFor="let file of solicitationFiles; let last = last"
											class="solicitation-file-item" [class.solicitation-file-item--last]="last">
											<div class="d-flex align-items-center gap-2 flex-grow-1 min-width-0">
												<div class="solicitation-file-item__icon">
													<i class="feather icon-file-text"></i>
												</div>
												<div class="d-flex flex-column min-width-0">
													<span class="font-weight-bolder text-truncate">{{ file.fileName
														}}</span>
													<span class="text-muted text-xs" *ngIf="file.generatedAt">
														Gerado em {{ file.generatedAt | date: 'dd/MM/yyyy HH:mm' }}
													</span>
												</div>
											</div>
											<div class="d-flex gap-1 flex-shrink-0">
												<button type="button" class="btn btn-icon btn-sm"
													ngbTooltip="Visualizar" [disabled]="isFileLoading(file.id)"
													(click)="previewMovementRequestFile(file)">
													<i data-feather="eye"></i>
												</button>
												<button type="button" class="btn btn-icon btn-sm" ngbTooltip="Baixar"
													[disabled]="isFileLoading(file.id)"
													(click)="downloadMovementRequestFile(file)">
													<i data-feather="download"></i>
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="mt-2 d-flex flex-column form-group">
								<label>Tipo de solicitação</label>
								<input class="form-control" value="{{ data?.solicitation?.movementTypeLabel }}"
									disabled />
							</div>

							<ng-container *ngIf="
                data?.solicitation?.movementType ===
                MovementType.TRAINNING.value
              ">
								<app-internal-training-form #solicitationFormRef [data]="data"
									[hiddenStandardFields]="hiddenStandardFields" [source]="source"
									(employeeLoadingChange)="onEmployeeLoadingChange($event)"></app-internal-training-form>
							</ng-container>

							<ng-container *ngIf="
                data?.solicitation?.movementType ===
                MovementType.APTITUDE_TRAINNING.value
              ">
								<ng-container
									*ngTemplateOutlet="requestAptitudeTrainingForm; context: { form: form }"></ng-container>
							</ng-container>

							<ng-container *ngIf="
                data?.solicitation?.movementType ===
                MovementType.DISMISSAL.value
              ">
								<app-dismissal-form #solicitationFormRef [data]="data"
									[hiddenStandardFields]="hiddenStandardFields" [source]="source"
									(employeeLoadingChange)="onEmployeeLoadingChange($event)"></app-dismissal-form>
							</ng-container>

							<ng-container *ngIf="
                data?.solicitation?.movementType ===
                MovementType.DISCIPLINARY_MEASURE.value
              ">
								<ng-container *ngTemplateOutlet="
                  requestDisciplinaryForm;
                  context: { form: form }
                "></ng-container>
								<ng-container *ngTemplateOutlet="
                  requestFeedback;
                  context: { form: form }
                "></ng-container>
							</ng-container>

							<ng-container *ngIf="
                data?.solicitation?.movementType ===
                MovementType.NEW_HIRING_SUBSTITUTION.value
              ">
								<ng-container *ngTemplateOutlet="
                  requestHiringSubstitutionForm;
                  context: { form: form }
                "></ng-container>
							</ng-container>

							<ng-container *ngIf="
                data?.solicitation?.movementType ===
                MovementType.NEW_HIRING_REPLACEMENT.value
              ">
								<ng-container *ngTemplateOutlet="
                  requestHiringReplacementForm;
                  context: { form: form }
                "></ng-container>
							</ng-container>

							<ng-container *ngIf="
                data?.solicitation?.movementType ===
                MovementType.NEW_HIRING_INCREASE.value
              ">
								<ng-container
									*ngTemplateOutlet="requestHiringForm; context: { form: form }"></ng-container>
							</ng-container>

							<ng-container *ngIf="
                data?.solicitation?.movementType ===
                MovementType.COST_CENTER_AND_JOB_TITLE_CHANGE.value
              ">
								<app-cost-center-change-form #solicitationFormRef [data]="data"
									[hiddenStandardFields]="hiddenStandardFields" [source]="source"
									[canChangeToDifferentCostCenter]="canChangeToDifferentCostCenter"
									(employeeLoadingChange)="onEmployeeLoadingChange($event)"></app-cost-center-change-form>
							</ng-container>

							<ng-container *ngIf="
                data?.solicitation?.movementType ===
                MovementType.PROMOTION.value
              ">
								<app-promotion-form #solicitationFormRef [data]="data"
									[hiddenStandardFields]="hiddenStandardFields" [source]="source"
									(employeeLoadingChange)="onEmployeeLoadingChange($event)"></app-promotion-form>
							</ng-container>
						</ng-container>

						<ng-container *ngIf="isDrawerSRequestWorkforcePlanDetails">
							<app-drawer-workforceplan-solicitation-planning #solicitationFormRef [data]="data"
								[source]="source"></app-drawer-workforceplan-solicitation-planning>
						</ng-container>

						<ng-container *ngTemplateOutlet="customFieldsSection"></ng-container>

						<div class="form-group">
							<label>Ressalvas / Observações</label>
							<textarea type="text" class="form-control" [(ngModel)]="justification"
								placeholder="Justificativa" rows="4" [disabled]="areApprovalInputFieldsDisabled"
								[ngModelOptions]="{ standalone: true }"></textarea>
						</div>

						<div class="form-group" *ngIf="isCancellationFormOpen">
							<label for="cancellationReason">Motivo do cancelamento *</label>
							<textarea id="cancellationReason" class="form-control" rows="3" maxlength="1000"
								placeholder="Informe por que a solicitação está sendo cancelada"
								[(ngModel)]="cancellationReason" [ngModelOptions]="{ standalone: true }"
								[disabled]="isSubmittingForm"></textarea>
						</div>

						<div
							class="drawer-workforce-plan-solicitation-actions drawer-actions d-flex gap-4 justify-content-between mb-2">
							<button type="button" class="btn btn-light" (click)="handleCancel()"
								[disabled]="statusDrawer === 'submitting' || isSubmittingForm">
								Fechar
							</button>

							<div class="d-flex align-items-center gap-2">
								<ng-container *ngIf="canCancelSolicitation">
									<button *ngIf="!isCancellationFormOpen" type="button" class="btn btn-outline-danger"
										(click)="openCancellationForm()" [disabled]="isSubmittingForm">
										Cancelar solicitação
									</button>
									<button *ngIf="isCancellationFormOpen" type="button" class="btn btn-danger"
										(click)="handleSubmitCancellation()"
										[disabled]="isSubmittingForm || !cancellationReason?.trim()">
										Confirmar cancelamento
									</button>
								</ng-container>

								<ng-container *ngIf="canExecute && !isCancellationFormOpen">
									<div *ngIf="
									data?.solicitation?.movementType ===
									MovementType.WORK_FORCEPLAN.value
									">
										<ng-container *ngIf="data?.solicitationDetails?.permission?.canExecute">
											<button *ngIf="isSubmittingForm == true" [disabled]="isSubmittingForm"
												class="btn btn-light" type="button">
												<span class="spinner-border spinner-border-xs text-dark"></span>
												Processando...
											</button>
											<ng-container *ngIf="isSubmittingForm == false">
												<btn-danger class="mr-1" [disabled]="statusDrawer === 'submitting'"
													label="Recusar" (click)="handleSubmitDecline()"></btn-danger>
												<button
													[disabled]="isSubmittingForm || !isCurrentSolicitationFormValid || isTrainingCompletionBlocked"
													type="button" (click)="handleSubmitApprove()"
													class="btn btn-primary ng-star-inserted">
													Aprovar
												</button>
											</ng-container>
										</ng-container>
									</div>
									<div *ngIf="
                  data?.solicitation?.movementType !==
                  MovementType.WORK_FORCEPLAN.value
                ">
										<button *ngIf="isSubmittingForm == true" [disabled]="isSubmittingForm"
											class="btn btn-primary" type="button">
											<span class="spinner-border spinner-border-xs text-white"></span>
										</button>
										<div #actionsDropdown ngbDropdown container="body"
											dropdownClass="dropdown-menu-customized" placement="top-right">
											<button *ngIf="isSubmittingForm == false"
												class="btn btn-primary no-dropdown-toggle-icon no-boxshadow"
												type="button" ngbDropdownToggle>
												<span>Ações</span>
												<i data-feather="chevron-down" appFeatherIcon></i>
											</button>
											<div ngbDropdownMenu class="dropdown-menu p-0">
												<!-- <ng-container *ngIf="canUpdate">
											<a [disabled]="statusDrawer === 'submitting'" rippleEffect type="button" class="dropdown-item"
												(click)="handleSubmit()">
												Atualizar
											</a>
										</ng-container> -->
												<ng-container *ngIf="data?.solicitationDetails?.permission?.canExecute">
													<a [disabled]="statusDrawer === 'submitting' || !isCurrentSolicitationFormValid || isTrainingCompletionBlocked"
														rippleEffect type="button" class="dropdown-item"
														(click)="handleSubmitApprove()">
														<span
															*ngIf="data?.solicitationDetails?.permission?.canStop">Aprovar</span>
														<span
															*ngIf="!data?.solicitationDetails?.permission?.canStop">Dar
															ciência</span>
													</a>
													<a *ngIf="data?.solicitationDetails?.permission?.canStop"
														[disabled]="statusDrawer === 'submitting'" rippleEffect
														type="button" class="dropdown-item"
														(click)="handleSubmitDecline()">
														Recusar
													</a>
												</ng-container>
												<a *ngIf="canConvertAptitudeTraining"
													[disabled]="statusDrawer === 'submitting' || isSubmittingForm"
													rippleEffect type="button" class="dropdown-item"
													(click)="handleConvertAptitudeToInternalTraining()">
													Converter para Treinamento Padrão
												</a>
											</div>
										</div>
									</div>
								</ng-container>
							</div>
						</div>
					</ng-container>
				</ng-container>
			</form>
		</div>
	</div>
</div>

<ng-template #customFieldsSection>
	<div [formGroup]="customFieldsForm">
		<ng-container *ngIf="customFieldsLoading">
			<div class="d-flex align-items-center gap-2 text-muted">
				<span class="spinner-border spinner-border-sm text-primary"></span>
				<span>Carregando campos personalizados...</span>
			</div>
		</ng-container>

		<div *ngIf="!customFieldsLoading && customFieldsArray.controls.length > 0" formArrayName="customFields">


			<div *ngFor="let control of customFieldsArray.controls; let i = index" [formGroupName]="i"
				class="form-group">
				<label class="form-control-label">
					{{ control.get('label')?.value }}
					<span
						*ngIf="control.get('required')?.value && !control.get('readOnly')?.value && !areApprovalInputFieldsDisabled"
						class="text-danger">*</span>
					<small *ngIf="control.get('readOnly')?.value" class="text-muted ml-1">(preenchido em etapa
						anterior)</small>
				</label>

				<ng-container [ngSwitch]="control.get('inputType')?.value">
					<ng-select *ngSwitchCase="'SELECT'" class="auto-grow-options"
						[items]="control.get('options')?.value" bindValue="value" bindLabel="label"
						formControlName="value" appendTo="body" placeholder="Selecione"
						[readonly]="areApprovalInputFieldsDisabled || control.get('readOnly')?.value">
					</ng-select>

					<ng-select *ngSwitchCase="'RADIO_OPTION'" class="auto-grow-options"
						[items]="control.get('options')?.value" bindValue="value" bindLabel="label"
						formControlName="value" appendTo="body" placeholder="Selecione"
						[readonly]="areApprovalInputFieldsDisabled || control.get('readOnly')?.value">
					</ng-select>

					<ng-select *ngSwitchCase="'TRUE_OR_FALSE'" class="auto-grow-options"
						[items]="control.get('options')?.value" bindValue="value" bindLabel="label"
						formControlName="value" appendTo="body" placeholder="Selecione"
						[readonly]="areApprovalInputFieldsDisabled || control.get('readOnly')?.value">
					</ng-select>

					<ng-select *ngSwitchCase="'MULTISELECT'" class="auto-grow-options"
						[items]="control.get('options')?.value" bindValue="value" bindLabel="label"
						formControlName="value" [multiple]="true" appendTo="body" placeholder="Selecione"
						[readonly]="areApprovalInputFieldsDisabled || control.get('readOnly')?.value">
					</ng-select>

					<ng-select *ngSwitchCase="'RADIO_OPTION_MULTISELECT'" class="auto-grow-options"
						[items]="control.get('options')?.value" bindValue="value" bindLabel="label"
						formControlName="value" [multiple]="true" appendTo="body" placeholder="Selecione"
						[readonly]="areApprovalInputFieldsDisabled || control.get('readOnly')?.value">
					</ng-select>

					<input *ngSwitchCase="'DATE'" type="date" class="form-control" formControlName="value" />

					<textarea *ngSwitchCase="'TEXTAREA'" class="form-control" rows="3"
						formControlName="value"></textarea>

					<input *ngSwitchCase="'NUMERIC'" type="text" class="form-control" formControlName="value"
						placeholder="R$ 0,00" appCurrencyCentsInput />

					<input *ngSwitchDefault type="text" class="form-control" formControlName="value"
						placeholder="Digite o valor" />
				</ng-container>

				<app-error-msg [control]="control.get('value')" [label]="control.get('label')?.value">
				</app-error-msg>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #requestAptitudeTrainingForm let-form="form">
	<div [formGroup]="form">
		<div *ngIf="isAdmin" class="form-group d-flex align-items-center training-type-group">
			<label class="form-control-label" for="trainingTypeId" class="me-2 mb-0">Tipo de treinamento</label>
			<a href="javascript:void(0)" class="link-primary d-flex align-items-center px-2"
				(click)="openTrainingModal()">
				Gerenciar Treinamentos
			</a>
		</div>

		<div *ngIf="!isStandardFieldHidden('trainingTypeId')" class="form-group">
			<ng-select class="auto-grow-options" [items]="trainingOptions" bindValue="value" bindLabel="label"
				placeholder="Tipo de treinamento" formControlName="trainingTypeId">
			</ng-select>
			<app-error-msg [control]="form.controls['trainingTypeId']" [label]="'trainingTypeId'">
			</app-error-msg>
		</div>

		<div class="form-group" *ngIf="data?.mode === 'add'">
			<label class="form-control-label" for="">Colaborador</label>

			<ng-container *ngIf="data?.hasSubType">
				<div class="form-group">
					<ng-select class="auto-grow-options" [items]="lists.activeEmployees" bindValue="id" bindLabel="name"
						placeholder="Colaborador" formControlName="employeeId"
						(change)="onActiveEmployeeChanged($event)">
					</ng-select>
				</div>
			</ng-container>

			<ng-container *ngIf="!data?.hasSubType">
				<app-employee-info-display [employee]="data?.employee"></app-employee-info-display>
			</ng-container>
		</div>

		<div *ngIf="!isStandardFieldHidden('costCenterId')" class="form-group">
			<label class="form-control-label" for="group">Centro de custo para o treinamento</label>
			<ng-select class="cost-centers-options auto-grow-options"
				[attr.data-tooltip]="getSelectedOptionText(lists.centerCostsOptions, form.get('costCenterId')?.value)"
				[items]="lists.centerCostsOptions" bindValue="value" bindLabel="label"
				(change)="onTrainingCenterCostChanged($event, 'costCenterId')" formControlName="costCenterId"
				[readonly]="data?.hasSubType">
			</ng-select>
			<app-error-msg [control]="form.controls['costCenterId']" [label]="'costCenterId'">
			</app-error-msg>
		</div>

		<div *ngIf="!isStandardFieldHidden('jobTitleGroupId')" class="form-group">
			<label class="form-control-label" for="group">Cargo para o treinamento</label>
			<ng-select class="auto-grow-options" title="Cargo para o treinamento" [items]="lists.jobTitleGroupOptions"
				bindValue="value" bindLabel="label" placeholder="Cargo para o treinamento"
				formControlName="jobTitleGroupId" (change)="onJobTitleGroupChanged($event)"
				[readonly]="data?.hasSubType">
			</ng-select>
			<app-error-msg [control]="form.controls['jobTitleGroupId']" [label]="'jobTitleGroupId'">
			</app-error-msg>
		</div>

		<div *ngIf="!isStandardFieldHidden('jobTitleId')" class="form-group">
			<label class="form-control-label" for="group">Função para o treinamento</label>
			<ng-select class="cost-centers-options auto-grow-options"
				[attr.data-tooltip]="getSelectedOptionText(lists.jobTitleOptions, form.get('jobTitleId')?.value)"
				[items]="lists.jobTitleOptions" bindValue="value" bindLabel="label"
				placeholder="Função para o treinamento" formControlName="jobTitleId" [readonly]="isJobtitleDisabled"
				(change)="onJobTitleChanged($event)">
			</ng-select>
			<app-error-msg [control]="form.controls['jobTitleId']" [label]="'jobTitleId'">
			</app-error-msg>
		</div>

		<ng-container *ngIf="canShowFieldToStartTraining">
			<div *ngIf="!isStandardFieldHidden('startTrainingDate')" class="form-group">
				<label class="form-control-label" for="">Data início</label>
				<input type="date" class="form-control" formControlName="startTrainingDate"
					(change)="onStartDateChange($event)" />
				<app-error-msg [control]="form.controls['startTrainingDate']" [label]="'startTrainingDate'">
				</app-error-msg>
			</div>
		</ng-container>

		<ng-container *ngIf="canShowFieldToEndTraining">
			<div *ngIf="!isStandardFieldHidden('endTrainingDate')" class="form-group">
				<label class="form-control-label" for="">Data fim</label>
				<input type="date" class="form-control" formControlName="endTrainingDate" />
				<app-error-msg [control]="form.controls['endTrainingDate']" [label]="'endTrainingDate'">
				</app-error-msg>
			</div>

			<div *ngIf="!isStandardFieldHidden('isApproved')" class="form-group">
				<label class="form-control-label">O colaborador está APTO para a função?</label>
				<select class="form-control" id="isApproved" formControlName="isApproved">
					<option [ngValue]="null" disabled selected>Selecione</option>
					<option [ngValue]="true">SIM</option>
					<option [ngValue]="false">NÃO</option>
				</select>
				<app-error-msg [control]="form.controls['isApproved']" [label]="'isApproved'">
				</app-error-msg>
			</div>
		</ng-container>

		<div class="form-group">
			<label class="form-control-label" for="">Observações</label>
			<textarea type="text" class="form-control" formControlName="note"></textarea>
			<app-error-msg [control]="form.controls['note']" [label]="'note'">
			</app-error-msg>
		</div>
	</div>
</ng-template>

<ng-template #requestHiringForm let-form="form">
	<div [formGroup]="form">
		<div class="form-group">
			<label class="form-control-label" for="timeShiftId">Turno</label>
			<ng-select class="auto-grow-options" title="Turno" [items]="lists.timeShiftsOptions" bindValue="id"
				bindLabel="title" placeholder="Turno" formControlName="timeShiftId">
			</ng-select>
			<app-error-msg [control]="form.controls['timeShiftId']" [label]="'timeShiftId'">
			</app-error-msg>
		</div>

		<div class="form-group">
			<label class="form-control-label" for="jobTitleGroupId">Cargo</label>
			<ng-select class="cost-centers-options auto-grow-options" title="Cargo" [items]="lists.jobTitleGroupOptions"
				bindValue="value" bindLabel="label" placeholder="Cargo" formControlName="jobTitleGroupId"
				(change)="onJobTitleGroupChanged($event)">
			</ng-select>
			<app-error-msg [control]="form.controls['jobTitleGroupId']" [label]="'jobTitleGroupId'">
			</app-error-msg>
		</div>

		<div class="form-group">
			<label class="form-control-label" for="jobTitleId">Função</label>
			<ng-select class="cost-centers-options auto-grow-options"
				[attr.data-tooltip]="getSelectedOptionText(lists.jobTitleOptions, form.get('jobTitleId')?.value)"
				[items]="lists.jobTitleOptions" bindValue="value" bindLabel="label" placeholder="Função"
				formControlName="jobTitleId">
			</ng-select>
			<app-error-msg [control]="form.controls['jobTitleId']" [label]="'jobTitleId'">
			</app-error-msg>
		</div>

		<div class="form-group">
			<label class="form-control-label" for="amount">Quantidade</label>
			<input type="number" class="form-control" formControlName="amount" placeholder="Quantidade" />
			<app-error-msg [control]="form.controls['amount']" [label]="'Quantidade'">
			</app-error-msg>
		</div>

		<div class="form-group">
			<label class="form-control-label" for="group">Tipo de aumento</label>
			<ng-select class="auto-grow-options" title="Tipo de aumento" [items]="lists.hiringTypeOptions"
				bindValue="value" bindLabel="label" placeholder="Tipo de aumento" formControlName="raiseType"
				[readonly]="true">
			</ng-select>
			<app-error-msg [control]="form.controls['raiseType']" [label]="'raiseType'">
			</app-error-msg>
		</div>

		<div class="form-group">
			<label class="form-control-label" for="note">Justificativa</label>
			<textarea type="text" class="form-control" formControlName="note"></textarea>
			<app-error-msg [control]="form.controls['note']" [label]="'note'">
			</app-error-msg>
		</div>
	</div>
</ng-template>

<ng-template #requestHiringSubstitutionForm let-form="form">
	<div [formGroup]="form">
		<div class="form-group">
			<label class="form-control-label" for="">Colaborador</label>
			<ng-select class="auto-grow-options" title="Colaborador" [items]="lists.employeesResignationsOptions"
				bindValue="id" bindLabel="name" placeholder="Colaborador" formControlName="employeeId"
				(change)="onEmplooyeeChanged($event)" [readonly]="data?.hasSubType">
			</ng-select>
			<app-error-msg [control]="form.controls['employeeId']" [label]="'Colaborador'">
			</app-error-msg>
		</div>

		<div class="form-group">
			<label>
				{{ deadlineLabel ? 'Data do desligamento' : 'Data prevista para o desligamento' }}
			</label>
			<input type="date" class="form-control" formControlName="deadline" [readonly]="true" />
		</div>

		<div class="title">
			<span>Dados para a nova contratação</span>
		</div>

		<div class="form-group">
			<label class="form-control-label" for="group">Turno</label>
			<input type="text" class="form-control" [value]="employeeSelected?.timeshiftTitle" [readonly]="true" />
		</div>

		<div class="form-group" [attr.data-tooltip]="employeeSelected?.jobTitleName">
			<label class="form-control-label" for="">Função</label>
			<input type="text" class="form-control" [value]="employeeSelected?.jobTitleName" [readonly]="true" />
		</div>

		<div class="form-group">
			<label class="form-control-label" for="">Justificativa</label>
			<textarea type="text" class="form-control" formControlName="note"></textarea>
			<app-error-msg [control]="form.controls['note']" [label]="'note'">
			</app-error-msg>
		</div>
	</div>
</ng-template>

<ng-template #requestHiringReplacementForm let-form="form">
	<div [formGroup]="form">
		<div class="form-group">
			<label class="form-control-label" for="group">Tipo de aumento</label>
			<ng-select class="auto-grow-options" title="Tipo de aumento" [items]="lists.hiringTypeOptions"
				bindValue="value" bindLabel="label" placeholder="Tipo de aumento" formControlName="raiseType"
				[readonly]="true">
			</ng-select>
			<app-error-msg [control]="form.controls['raiseType']" [label]="'raiseType'">
			</app-error-msg>
		</div>

		<div class="form-group">
			<label class="form-control-label" for="group">Turno</label>
			<ng-select class="auto-grow-options" title="Turno" [items]="lists.timeShiftsOptions" bindValue="id"
				bindLabel="title" placeholder="Turno" formControlName="timeShiftId">
			</ng-select>
			<app-error-msg [control]="form.controls['timeShiftId']" [label]="'timeShiftId'">
			</app-error-msg>
		</div>

		<div class="form-group">
			<label class="form-control-label" for="group">Cargo</label>
			<input type="text" class="form-control" [value]="getEmployeeJobTitleGroupName()" disabled="true" />
		</div>

		<div class="form-group">
			<label class="form-control-label" for="group">Função</label>
			<ng-select class="auto-grow-options" [items]="lists.jobTitleOptions" bindValue="value"
				[attr.data-tooltip]="getSelectedOptionText(lists.jobTitleOptions, form.get('jobTitleId')?.value)"
				bindLabel="label" placeholder="Função" formControlName="jobTitleId" [readonly]="isJobtitleDisabled">
			</ng-select>
			<app-error-msg [control]="form.controls['jobTitleId']" [label]="'jobTitleId'">
			</app-error-msg>
		</div>

		<div class="form-group">
			<label class="form-control-label" for="">Justificativa</label>
			<textarea type="text" class="form-control" formControlName="note"></textarea>
			<app-error-msg [control]="form.controls['note']" [label]="'note'">
			</app-error-msg>
		</div>
	</div>
</ng-template>

<ng-template #employeeDetails let-form="form">
	<div class="employee-details-layout" [formGroup]="form"
		[class.employee-details-layout--feedbacks]="employeeDetailsActiveTab === 'feedbacks' || employeeDetailsActiveTab === 'salaryHistory'"
		[class.employee-details-layout--disciplinary-measure]="employeeDetailsActiveTab === 'disciplinaryMeasure'">
		<div class="employee-details-tabs">
			<button type="button" class="employee-details-tabs__item"
				[class.employee-details-tabs__item--active]="employeeDetailsActiveTab === 'registration'"
				[attr.aria-current]="employeeDetailsActiveTab === 'registration' ? 'page' : null"
				(click)="setEmployeeDetailsTab('registration')">
				<i class="feather icon-user employee-details-tabs__icon" aria-hidden="true"></i>
				Dados de cadastro
			</button>

			<button *ngIf="usesEmployeeFeedbacks && canViewSensitiveEmployeeDetailsTabs" type="button"
				class="employee-details-tabs__item"
				[class.employee-details-tabs__item--active]="employeeDetailsActiveTab === 'feedbacks'"
				[attr.aria-current]="employeeDetailsActiveTab === 'feedbacks' ? 'page' : null"
				(click)="setEmployeeDetailsTab('feedbacks')">
				<i class="feather icon-message-square employee-details-tabs__icon" aria-hidden="true"></i>
				Feedbacks
			</button>

			<button *ngIf="canViewSensitiveEmployeeDetailsTabs" type="button" class="employee-details-tabs__item"
				[class.employee-details-tabs__item--active]="employeeDetailsActiveTab === 'salaryHistory'"
				[attr.aria-current]="employeeDetailsActiveTab === 'salaryHistory' ? 'page' : null"
				(click)="setEmployeeDetailsTab('salaryHistory')">
				<i class="feather icon-dollar-sign employee-details-tabs__icon" aria-hidden="true"></i>
				Histórico Salarial
			</button>

			<button *ngIf="canViewSensitiveEmployeeDetailsTabs" type="button" class="employee-details-tabs__item"
				[class.employee-details-tabs__item--active]="employeeDetailsActiveTab === 'disciplinaryMeasure'"
				[attr.aria-current]="employeeDetailsActiveTab === 'disciplinaryMeasure' ? 'page' : null"
				(click)="setEmployeeDetailsTab('disciplinaryMeasure')">
				<i class="feather icon-alert-triangle employee-details-tabs__icon" aria-hidden="true"></i>
				Advertências
			</button>
		</div>

		<div class="employee-details-content" *ngIf="employeeDetailsActiveTab === 'registration'">
			<div class="employee-details-profile">
				<div class="employee-details-profile__avatar-wrap">
					<img [attr.alt]="'Foto de ' + (data?.employee?.name || 'colaborador')"
						class="employee-details-profile__avatar"
						[src]="data?.employee?.profileImagePath || 'assets/images/logo/avatar-profile.png'" />
				</div>

				<div class="employee-details-profile__name">{{ data?.employee?.name || '-' }}</div>
				<div class="employee-details-profile__meta" *ngIf="data?.employee?.registration">
					MAT: {{ data?.employee?.registration }}
				</div>
			</div>

			<div class="employee-details-sections">
				<section class="employee-details-section">
					<div class="employee-details-section__header">
						<h6 class="employee-details-section__title">Dados pessoais</h6>
						<div class="employee-details-section__divider"></div>
					</div>

					<div class="employee-details-grid">
						<div class="employee-details-field">
							<span class="employee-details-field__label">Data de nascimento</span>
							<span class="employee-details-field__value">
								{{ data?.employee?.birthday ? (data?.employee?.birthday | date : 'dd/MM/yyyy') : '-' }}
							</span>
						</div>

						<div class="employee-details-field">
							<span class="employee-details-field__label">Idade</span>
							<span class="employee-details-field__value">{{ data?.employee?.age ?? '-' }}</span>
						</div>
					</div>
				</section>

				<section class="employee-details-section">
					<div class="employee-details-section__header">
						<h6 class="employee-details-section__title">Vínculo</h6>
						<div class="employee-details-section__divider"></div>
					</div>

					<div class="employee-details-grid">
						<div class="employee-details-field">
							<span class="employee-details-field__label">Data de admissão</span>
							<span class="employee-details-field__value">
								{{ data?.employee?.admissionDate ? (data?.employee?.admissionDate | date : 'dd/MM/yyyy') : '-'
								}}
							</span>
						</div>

						<div class="employee-details-field">
							<span class="employee-details-field__label">Tempo de casa</span>
							<span class="employee-details-field__value">{{ data?.employee?.timeAtCompany || '-' }}</span>
						</div>

						<div class="employee-details-field">
							<span class="employee-details-field__label">Situação</span>
							<span class="employee-details-field__value">{{ data?.employee?.status || '-' }}</span>
						</div>

						<div class="employee-details-field">
							<span class="employee-details-field__label">Tabela de folga</span>
							<span class="employee-details-field__value">{{ data?.employee?.shiftSchedule || '-' }}</span>
						</div>

						<div class="employee-details-field" [attr.data-tooltip]="data?.employee?.jobTitleGroupName || ''">
							<span class="employee-details-field__label">Cargo</span>
							<span class="employee-details-field__value">{{ data?.employee?.jobTitleGroupName || '-' }}</span>
						</div>

						<div class="employee-details-field" [attr.data-tooltip]="data?.employee?.jobTitleName || ''">
							<span class="employee-details-field__label">Função</span>
							<span class="employee-details-field__value">{{ data?.employee?.jobTitleName || '-' }}</span>
						</div>

						<div class="employee-details-field">
							<span class="employee-details-field__label">Turno</span>
							<span class="employee-details-field__value">{{ data?.employee?.workScaleGroup || '-' }}</span>
						</div>
					</div>
				</section>

				<section class="employee-details-section">
					<div class="employee-details-section__header">
						<h6 class="employee-details-section__title">Contatos</h6>
						<div class="employee-details-section__divider"></div>
					</div>

					<div class="employee-details-grid">
						<div class="employee-details-field" [attr.data-tooltip]="employeeContactDisplay !== '-' ? employeeContactDisplay : ''">
							<span class="employee-details-field__label">Telefone</span>
							<span class="employee-details-field__value">{{ employeeContactDisplay }}</span>
						</div>

						<div class="employee-details-field" [attr.data-tooltip]="data?.employee?.email || ''">
							<span class="employee-details-field__label">E-mail</span>
							<span class="employee-details-field__value">{{ data?.employee?.email || '-' }}</span>
						</div>
					</div>
				</section>

				<section class="employee-details-section">
					<div class="employee-details-section__header">
						<h6 class="employee-details-section__title">Contato de emergência</h6>
						<div class="employee-details-section__divider"></div>
					</div>

					<div *ngIf="!hasEmergencyContactData" class="employee-details-empty-alert" role="status"
						aria-live="polite">
						<i class="custom-icon-information-circle employee-details-empty-alert__icon"
							aria-hidden="true"></i>
						<span>Nenhum contato de emergência cadastrado. O colaborador pode cadastrá-lo em Meu Perfil.</span>
					</div>

					<div *ngIf="hasEmergencyContactData" class="employee-details-grid">
						<div class="employee-details-field" [attr.data-tooltip]="emergencyNameDisplay !== '-' ? emergencyNameDisplay : ''">
							<span class="employee-details-field__label">Nome</span>
							<span class="employee-details-field__value">{{ emergencyNameDisplay }}</span>
						</div>

						<div class="employee-details-field" [attr.data-tooltip]="emergencyKinshipDisplay !== '-' ? emergencyKinshipDisplay : ''">
							<span class="employee-details-field__label">Parentesco</span>
							<span class="employee-details-field__value">{{ emergencyKinshipDisplay }}</span>
						</div>

						<div class="employee-details-field" [attr.data-tooltip]="emergencyPhoneDisplay !== '-' ? emergencyPhoneDisplay : ''">
							<span class="employee-details-field__label">Telefone</span>
							<span class="employee-details-field__value">{{ emergencyPhoneDisplay }}</span>
						</div>

						<div class="employee-details-field" [attr.data-tooltip]="emergencyEmailDisplay !== '-' ? emergencyEmailDisplay : ''">
							<span class="employee-details-field__label">E-mail</span>
							<span class="employee-details-field__value">{{ emergencyEmailDisplay }}</span>
						</div>
					</div>
				</section>

				<section class="employee-details-section">
					<div class="employee-details-section__header">
						<h6 class="employee-details-section__title">Fardamento</h6>
						<div class="employee-details-section__divider"></div>
					</div>

					<div class="employee-details-grid">
						<div class="employee-details-field">
							<span class="employee-details-field__label">Tamanho da roupa</span>
							<span class="employee-details-field__value">{{ data?.employee?.shirtSize || '-' }}</span>
						</div>

						<div class="employee-details-field">
							<span class="employee-details-field__label">Número da calça</span>
							<span class="employee-details-field__value">{{ data?.employee?.pantsSize != null &&
								data?.employee?.pantsSize !== '' ? data?.employee?.pantsSize : '-' }}</span>
						</div>

						<div class="employee-details-field">
							<span class="employee-details-field__label">Número do calçado</span>
							<span class="employee-details-field__value">{{ data?.employee?.shoeSize != null &&
								data?.employee?.shoeSize !== '' ? data?.employee?.shoeSize : '-' }}</span>
						</div>
					</div>
				</section>
			</div>
		</div>

		<div class="employee-details-feedbacks-panel"
			*ngIf="employeeDetailsActiveTab === 'feedbacks' && usesEmployeeFeedbacks && canViewSensitiveEmployeeDetailsTabs">
			<app-employee-details-feedbacks [employeeId]="data?.employee?.id"></app-employee-details-feedbacks>
		</div>

		<div class="employee-details-salary-history-panel"
			*ngIf="employeeDetailsActiveTab === 'salaryHistory' && canViewSensitiveEmployeeDetailsTabs">
			<app-employee-details-salary-history [employeeId]="data?.employee?.id"
				[currentJobTitleName]="data?.employee?.jobTitleName"></app-employee-details-salary-history>
		</div>

		<div class="employee-details-disciplinary-measure-panel"
			*ngIf="employeeDetailsActiveTab === 'disciplinaryMeasure' && canViewSensitiveEmployeeDetailsTabs">
			<app-employee-details-disciplinary-measure
				[employeeId]="data?.employee?.id"></app-employee-details-disciplinary-measure>
		</div>
	</div>
</ng-template>

<ng-template #requestDisciplinaryForm let-form="form">
	<div [formGroup]="form">
		<ng-container *ngIf="data?.mode === 'add'">
			<div class="form-group">
				<label class="form-control-label" for="">Colaborador</label>

				<app-employee-info-display [employee]="data?.employee"></app-employee-info-display>
			</div>
		</ng-container>

		<div class="form-group" [attr.data-tooltip]="data?.employee?.costCenterName">
			<label class="form-control-label" for="group">Centro de Custo</label>
			<select class="form-control cost-centers-options auto-grow-options" [disabled]="true">
				<option selected value="{{ data?.employee?.costCenterName }}">
					{{ data?.employee?.costCenterName }}
				</option>
			</select>
		</div>

		<div *ngIf="!isStandardFieldHidden('occurenceDate')" class="form-group">
			<label class="form-control-label" for="">Data da Ocorrência</label>
			<input type="date" class="form-control" formControlName="occurenceDate" placeholder="Data da Ocorrência" />
			<app-error-msg [control]="form.controls['occurenceDate']" [label]="'occurenceDate'">
			</app-error-msg>
		</div>

		<div *ngIf="!isStandardFieldHidden('occurenceType')" class="form-group">
			<label class="form-control-label" for="group">Tipo da Ocorrência</label>
			<ng-select container="body" class="cost-centers-options auto-grow-options" title="Tipo da Ocorrência"
				[items]="occurrenceTypeDisciplinaryMeasureOptions" bindValue="value" bindLabel="label"
				placeholder="Tipo da Ocorrência" formControlName="occurenceType"
				(change)="ondisciplinaryMeasureChange($event)">
			</ng-select>
			<app-error-msg [control]="form.controls['occurenceType']" [label]="'occurenceType'">
			</app-error-msg>
		</div>

		<div *ngIf="isSuspension && !isStandardFieldHidden('amountDays')" class="form-group">
			<label class="form-control-label" for="amountDays">Quantidade de Dias</label>
			<input type="number" class="form-control" formControlName="amountDays" placeholder="Quantidade" />
			<app-error-msg [control]="form.controls['amountDays']" [label]="'Quantidade'">
			</app-error-msg>
		</div>

		<div *ngIf="showOccurrenceJustification && !isStandardFieldHidden('occurrenceJustification')"
			class="form-group">
			<label class="form-control-label" for="group">Justificativa da Ocorrência</label>
			<ng-select container="body" class="cost-centers-options auto-grow-options"
				title="Justificativa da Ocorrência" [items]="justificationOccurrenceDisciplinaryMeasureOptions"
				bindValue="value" bindLabel="label" placeholder="Justificativa da Ocorrência"
				formControlName="occurrenceJustification">
			</ng-select>
			<app-error-msg [control]="form.controls['occurrenceJustification']" [label]="'occurrenceJustification'">
			</app-error-msg>
		</div>

		<div class="form-group">
			<label class="form-control-label" for="note">Observações</label>
			<textarea type="text" class="form-control" formControlName="note"></textarea>
			<app-error-msg [control]="form.controls['note']" [label]="'note'">
			</app-error-msg>
		</div>
	</div>
</ng-template>

<ng-template #requestFeedback let-form="form">
	<div [formGroup]="form">
		<ng-container *ngIf="data?.mode === 'add'">
			<div class="form-group">
				<label class="form-control-label" for="">Colaborador</label>
				<app-employee-info-display [employee]="data?.employee"></app-employee-info-display>
			</div>
		</ng-container>

		<app-received-feedback-list [organicFeedback]="true" #feedbackList
			[employeeId]="form.get('employeeId')?.value"></app-received-feedback-list>

	</div>
</ng-template>